import { motion } from "motion/react";
import { Link } from "react-router-dom";
import type { Product } from "@/src/types";

interface ProductCardProps {
    product: Product;
    index: number;
    onAddToCart: (product: Product) => void;
}

export function ProductCard({ product, index, onAddToCart }: ProductCardProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group cursor-pointer"
        >
            <Link to={`/product/${product.id}`}>
                <div className="relative aspect-[4/5] overflow-hidden mb-6 rounded-sm">
                    <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        referrerPolicy="no-referrer"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
                    <div className="px-6 absolute z-10 bottom-6 w-full">
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onAddToCart(product);
                            }}
                            className="mt-4 w-full border border-stone-200 bg-white py-3 text-xs uppercase tracking-widest opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 hover:border-stone-900 hover:bg-stone-900 hover:text-white"
                        >
                            Add to Bag
                        </button>
                    </div>
                </div>
                <div className="space-y-2">
                    <div className="flex justify-between items-start">
                        <h3 className="font-serif text-2xl group-hover:italic transition-all">
                            {product.name}
                        </h3>
                        <span className="font-light">£{product.price}</span>
                    </div>
                    <p className="text-stone-400 text-sm italic">
                        {product.scent}
                    </p>
                    <div className="flex gap-2 pt-2">
                        {product.notes.map((note) => (
                            <span
                                key={note}
                                className="text-[10px] uppercase tracking-wider bg-stone-100 px-2 py-1 rounded-full text-stone-500"
                            >
                                {note}
                            </span>
                        ))}
                    </div>
                </div>
            </Link>
        </motion.div>
    );
}
